import React, {  useCallback, useEffect, useState } from 'react'
import {  useHistory, useParams } from 'react-router-dom'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import WizardHeader from 'components/VirtualPortal/components/WizardHeader'
import GenericPopUpModal from 'components/VirtualPortal/components/PopUpModal'
import LoadingScreen from 'components/VirtualPortal/components/LoadingScreen'
import noImage from 'images/no_image.png'
import dragonDropActive from 'images/drag-drop-active.png'
import dragonDropInactive from 'images/drag-drop-inactive.png'
import './wishlist-rank.css'

const WishlistRank = () => {
  const params = useParams()
  const history = useHistory()
  const [state, setState] = useState({
    initialPotentialContactCount: 0,
    potentialWishlistContacts: [],
    wishlistContacts: [],
    saving: false,
    isRefreshing: true
  })
  const [content, setContent] = useState(null)
  const { wizard, token } =  params
  let endpoint = wizard ? '/wishlist/wizard' : '/wishlist'
  const link = '/' + params.token + endpoint
  const noSelections = state.wishlistContacts.length === 0 ? '' : 'hide'
  const hidden = state.initialPotentialContactCount === 0 ? 'hide' : ''

  useEffect(() => {
    window.api.get('/virtual_portal/event_one_on_one_meeting_wishlists').then((response) => {
      let potentialWishlistContacts = response.data.event_one_on_one_meeting_wishlists.event_one_on_one_meetings_wishlisted
      const potentialWishlistSurveyUserIds = potentialWishlistContacts.map(({survey_user_id}) => {return survey_user_id})
      const wishlistSurveyUserIds = response.data.event_one_on_one_meeting_wishlists.event_one_on_one_meeting_wishlists.map(({impacted_survey_user_id}) => {return impacted_survey_user_id})
      const wishlistContacts = response.data.event_one_on_one_meeting_wishlists.event_one_on_one_meeting_wishlists.map(({id, other_photo, other_full_name, other_title, other_organization_name, impacted_survey_user_id, other_bio}) => {
        return { id: id, photo: other_photo, full_name: other_full_name, title: other_title, organization_name: other_organization_name, bio: other_bio, on_other_wishlist: potentialWishlistSurveyUserIds.includes(impacted_survey_user_id) }
      })
      // remove duplicates
      potentialWishlistContacts = potentialWishlistContacts.filter((wishlist) => {
        return !wishlistSurveyUserIds.includes(wishlist.survey_user_id)
      })

      setState({
        ...state,
        isRefreshing: false,
        initialPotentialContactCount: potentialWishlistContacts.length,
        wishlistContacts,
        potentialWishlistContacts,
      })
    })
  },[])

  const handleOnDragEnd = useCallback((result) => {
    if (!result.destination) return
    // Moving into the wishlist rank
    const wishlistContacts = Array.from(state.wishlistContacts)
    const potentialWishlistContacts = Array.from(state.potentialWishlistContacts)
    if(result.destination.droppableId == 'wishlistContacts' && result.source.droppableId == 'potentialWishlistContacts'){
      const [reorderedItem] = potentialWishlistContacts.splice(result.source.index, 1)
      reorderedItem.added = true
      reorderedItem.on_other_wishlist = true
      wishlistContacts.splice(result.destination.index, 0, reorderedItem)
    } else {
      const [reorderedItem] = wishlistContacts.splice(result.source.index, 1)
      wishlistContacts.splice(result.destination.index, 0, reorderedItem)
    }
    setState({...state, potentialWishlistContacts, wishlistContacts })

  },[state])

  const image = useCallback((user) => {
    if(user?.photo) {
      return `<img class='rounded-circle' height='80' width='80' src=${user.photo} alt='' />`
    } else {
      return `<img height='80' src=${noImage} alt='' />`
    }
  },[])

  const bio = useCallback((user) => {
    if(user?.bio) {
      return `<p>${user.bio}</p>`
    } else {
      return '<p>No information provided.</p>'
    }
  },[])

  const openUserDetailPopUp = useCallback((index, type) => {
    const user = state[type][index]
    let user_header = ''
    if(user){
      user_header =  `
      <div class='user-list'>
      ${image(user)}
      <div class='user-info'>
        <div class='full-name'>${user.full_name}</div>
        <div class='title'>${user.title}</div>
        <div class='account-name'>${user.organization_name}</div>
      </div>
    </div>
    `
    }
    setContent(user_header + `<div><p><strong>Bio</strong></p>${bio(user)}</div>`)
  },[image, content, state])

  const removeFromWishlist = useCallback((index) => {
    const wishlistContacts = Array.from(state.wishlistContacts)
    const removed = wishlistContacts.splice(index, 1)
    setState({...state, wishlistContacts })
    // This record wasn't pulled up from the top 5 (so we have to actually delete the record)
    if(!removed[0].added) {
      window.api.delete('/virtual_portal/delete_event_one_on_one_meeting_wishlists/' + removed[0].id )
    }
  },[state])

  const toggleBlock = useCallback((index) => {
    const potentialWishlistContacts = state.potentialWishlistContacts
    if(potentialWishlistContacts[index].blocked_event_wishlist_one_on_one_meeting_id) {
      // UNBLOCK
      window.api.delete('/virtual_portal/delete_event_one_on_one_meeting_wishlists/' + potentialWishlistContacts[index].blocked_event_wishlist_one_on_one_meeting_id )
      potentialWishlistContacts[index].blocked_event_wishlist_one_on_one_meeting_id = null

      setState({...state, potentialWishlistContacts})
    } else {
      // BLOCK
      const data = { event_one_on_one_meeting_wishlist:
        {
          is_blocked: true,
          survey_user_id: potentialWishlistContacts[index].impacted_survey_user_id,
          impacted_survey_user_id: potentialWishlistContacts[index].survey_user_id
        }
      }
      window.api.post('/virtual_portal/create_event_one_on_one_meeting_wishlists', data).then((response) => {
        potentialWishlistContacts[index].blocked_event_wishlist_one_on_one_meeting_id = response.data.event_one_on_one_meeting_wishlist.id
        setState({...state, potentialWishlistContacts})
      })
    }
  }, [state])

  const submit = useCallback((direction) => {
    setState({ ...state, saving: true })
    window.api.post('/virtual_portal/rank_event_one_on_one_meeting_wishlists', { event_one_on_one_meeting_wishlists: state.wishlistContacts } )
      .then(() => {
        endpoint = params.wizard ? '/availability/wizard' : ''
        if(direction === 'forward'){
          history.push('/' + token + endpoint)
        } else {
          history.push('/' + token + '/wishlist/wizard')
        }
      }).catch(() => {
        setState({...state, saving:false})
      })
  },[[params, state, history, endpoint, token]])

  const closeModal = useCallback(() => setContent(null), [])

  if(window.LiveChatWidget) {
    if(wizard) {
      window.LiveChatWidget.call('hide')
    } else {
      window.LiveChatWidget.call('minimize')
    }
  }

  return(
    <div className='wishlist-rank-page wizard-form'>
      <WizardHeader
        wizard={wizard}
        activeTab='wishlist_rank' />
      { state.isRefreshing ? <LoadingScreen /> : '' }
      <h3>Rank your preferences for peer-to-peer meetings</h3>
      <p>Please press and hold the arrows to move and reorder your ranking preferences.</p>
      <p>If you select &apos;Remove,&apos; the person is removed from your list (They will not be able to see that you blocked them). They can be added back in by returning to the &apos;My Preferences&apos; page.</p>
      <DragDropContext onDragEnd={handleOnDragEnd}>
        <div className='wishlist-grid-container'>
          <div className='wishlist-grid-header'>Meeting Participant</div>
        </div>
        <Droppable droppableId="wishlistContacts">
          {(provided) => (
            <div className='wishlistContacts' {...provided.droppableProps} ref={provided.innerRef}>
              {state.wishlistContacts.map(({id, full_name, title, organization_name, on_other_wishlist}, index) => {
                return (
                  <Draggable key={`key${id}`} draggableId={`key${id}`} index={index}>
                    {(provided) => (
                      <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} >
                        <div className='wishlistDraggable' >
                          <div><img src={dragonDropActive} /><strong className='rank'>{index + 1}</strong></div>
                          <div className='user-detail'><a className='user-detail-link' onClick={() => openUserDetailPopUp(index, 'wishlistContacts')}>{ full_name }</a>, { title }, { organization_name }</div>
                          <span className='informational'>{on_other_wishlist ? 'ALSO CHOSE YOU' : ''}</span>
                          <button onClick={() => removeFromWishlist(index) } className='action-button'>REMOVE</button>
                        </div>
                        { content &&
                          <GenericPopUpModal
                            customClass='wishlist-user-info'
                            handleCloseGenericModal={closeModal}
                            content={content} >
                          </GenericPopUpModal>
                        }
                      </div>
                    )}
                  </Draggable>
                )
              })}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
        <p className={noSelections}>You have no selections to rank. Please go to the <a href={link}>&quot;My Preferences&quot;</a> page to update your meeting preferences.</p>
        <div className={'top-rankings-section margin-top-40 ' + hidden}>
          <h3>Top Listing</h3>
          <p>This list shows executives who have ranked you among their top peers to meet with. If you would like to meet with them, you can use the arrows to drag the lines up to your ranked list above.</p>
          <p>If you select &quot;Block,&quot; that person will not be able to schedule a meeting with you.</p>
          <div className='wishlist-grid-container'>
            <div className='wishlist-grid-header'></div>
            <div className='wishlist-grid-header'><span>Participant</span></div>
          </div>
          <Droppable isDropDisabled={ true } droppableId="potentialWishlistContacts">
            {(provided) => (
              <div className="potentialWishlistContacts" {...provided.droppableProps} ref={provided.innerRef}>
                {state.potentialWishlistContacts.map(({id, full_name, title, organization_name, blocked_event_wishlist_one_on_one_meeting_id}, index) => {
                  return (

                    <Draggable isDragDisabled={ blocked_event_wishlist_one_on_one_meeting_id != null ? true : false} key={'key' + id} draggableId={'key' + id} index={index}>
                      {(provided) => (
                        <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} >
                          <div className='wishlistDraggable'>
                            <img src={ blocked_event_wishlist_one_on_one_meeting_id == null ? dragonDropActive : dragonDropInactive} />
                            <div className='user-detail'>
                              <a className='user-detail-link' onClick={() => openUserDetailPopUp(index, 'potentialWishlistContacts')}>{ full_name }</a>, { title }, { organization_name }
                            </div>
                            <span className='informational'>{ blocked_event_wishlist_one_on_one_meeting_id ? 'YOU BLOCKED THEM' : '' }</span>
                            <button onClick={() => toggleBlock(index) } className={ blocked_event_wishlist_one_on_one_meeting_id ? 'inaction-button' : 'action-button' }>{ blocked_event_wishlist_one_on_one_meeting_id ? 'UNBLOCK' : 'BLOCK' }</button>
                          </div>
                          { content &&
                            <GenericPopUpModal
                              customClass='wishlist-user-info'
                              handleCloseGenericModal={closeModal}
                              content={content} >
                            </GenericPopUpModal>
                          }
                        </div>
                      )}
                    </Draggable>
                  )
                })}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </div>
      </DragDropContext>
      <div className='bottom-buttons margin-top-40'>
        { wizard ?
          <button onClick={ () => submit('backward') } className='submit previous'>
              SAVE & PREVIOUS
          </button>
          : '' }
        <button
          disabled={state.saving}
          onClick={ () => submit('forward') }
          className='submit'>
          {state.saving ? (<i className="fa fa-refresh fa-spin"></i>) : ''}
          { wizard ? 'SAVE & CONTINUE' : 'SAVE'}
        </button>
      </div>
    </div>

  )
}

export default WishlistRank

